import _ from "lodash";

import { take, call, put, fork, spawn } from "redux-saga/effects";

import { AuthGet, AuthReset } from "core/Auth";
import { Copy } from "kit/ui";
import QueryString from "core/QueryString";
import ErrorLoggerService from "core/ErrorLoggerService";

import { appActions } from "../containers/App/App.slice";
import {
  getCustomerPayloadWithToken,
  checkCampaignParameters
} from "../containers/Shared/Shared.saga";
import { getRoute, handleUserLogin } from "../containers/App/App.saga";

import routesObject from "../routesObject";

const ROUTE_KEYS_TO_PREVENT_TOKEN_CHECK = [
  routesObject.handover.key
];

export function* initSaga() {
  try {
    const currentRoute = yield call(getRoute);
    yield put(appActions.initStart());
    yield fork(checkCampaignParameters);

    const searchParams = QueryString.parse(window.location.search);

    const { token: tokenFromStore } = AuthGet();
    const tokenFromUrl = searchParams?.jwt;
    const token = tokenFromUrl || tokenFromStore;

    if (ROUTE_KEYS_TO_PREVENT_TOKEN_CHECK.includes(currentRoute.key)) return;
    if (token) {
      const { memberDetails } = yield call(getCustomerPayloadWithToken, token);
      if (memberDetails) {
        yield spawn(handleUserLogin, {
          token,
          memberDetails
        });
        yield take(appActions.authUserLogin);
        if (tokenFromUrl) {
          Copy.copyStr(`?jwt=${tokenFromUrl}`);
        }
      }
      else {
        yield put(appActions.authUserLogout());
      }
    }
  }
  catch (err) {
    yield call(AuthReset);
    ErrorLoggerService("APP", "appInitSaga", err);
  }
  finally {
    yield put(appActions.initFinish());
  }
}

export default function* sagaWatcher() {
  yield fork(initSaga);
}
